import { Avatar, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, InputLabel, Pagination, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import { useAssignClientStatusMutation, useExternalRecruiterListMutation, useGetRecruiterAssignClientsMutation, useInternalRecruiterListMutation, useRecruiterClientAssignedListMutation, useRecruiterClientAssignMutation, useRecruiterDropDownQuery, useRecruiterJobListMutation, useRecruiterListMutation, useUnassignMappedClientMutation } from "../../redux/Recruiters/Recruiters.api";
import { useContext, useEffect, useState } from "react";
import Dropdown from "../../reusable_components/components/Dropdown";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import { useNavigate } from "react-router-dom";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import './Recruiters.css'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import MUIButton from "../../reusable_components/components/MUIButton";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import SearchIconLg from "../../assets/Icons/SearchIcon";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { updateExternalRecruiter, updateRecruiterIdAdmin, updateRecruiterStatus } from "../../redux/common/common.slice";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import { useGetClientDropdownForJobQuery } from "../../redux/jobpostings/jobpostings.api";
import DeleteIcon from '../../assets/Icons/DeleteIcon'
import Switch from '@mui/material/Switch';
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AddIcon from '@mui/icons-material/Add';
import { TrendingUpDown } from 'lucide-react';

const Recruiters = () => {
    const commonFilter = JSON.parse(localStorage.getItem('commonsearchfilter'))
    const [recruiterName, setRecruiterName] = useState(commonFilter?.recruiter?.name || "")
    const [recruiterId, setRecruiterId] = useState(commonFilter?.recruiter?.id || "")
    const [address, setAddress] = useState(commonFilter?.recruiter?.address || "")
    const [company, setCompany] = useState(commonFilter?.recruiter?.company || "")
    const [emailOrPhone, setEmailOrPhone] = useState(commonFilter?.recruiter?.emailOrPhone || "")
    const [selectedType, setSelectedType] = useState(commonFilter?.recruiter?.status || "")
    const [searchKeyword, setSearchKeyword] = useState("")

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { Snackbar } = useContext(SnackbarContext)

    const [internalRecruiters, setInternalRecruiter] = useState([])
    const [externalRecruiter, setExternalRecruiter] = useState([])
    const [recruiterJobListDetails, setRecruiterJobListDetails] = useState([])
    const [sortingDirection, setSortingDirection] = useState('DESC')
    const [sortingColumn, setSortingColumn] = useState('created_date')
    const [triggerApi, setTriggerApi] = useState(false)
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [showClearFilter, setShowClearFilter] = useState(false)
    const [mappingClient, setMappingClient] = useState("")
    const [recruiterUserId, setRecruiterUserId] = useState()
    const [assignClientToRecruiterList, setAssignClientList] = useState([])


    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0)
    const [externalCount, setExternalCount] = useState(0)
    const [page, setPage] = useState(+localStorage.getItem('recruitersNewPage') || 1)
    const [externalPage, setExternalPage] = useState(+localStorage.getItem('externalRecruiterNewPage') || 1)
    const [FilterDialogOpen, setFilterDialogOpen] = useState(false)
    const [shouldFetch, setShouldFetch] = useState(false);
    const [openWarningDialog, setOpenWarningDialog] = useState(false);


    const [value, setValue] = useState(() => {
        return localStorage.getItem("tabValue") || '0'
    });


    const handleChange = (event, newValue) => {
        localStorage.setItem("tabValue", newValue)
        setPage(1)
        setValue(newValue);
        setSearchKeyword("")
        handleClearFilterChange()
    };

    const handleFilterDialogOpen = () => {
        if (chips.length === 0) {
            setRecruiterId("")
            setRecruiterName("")
            setCompany("")
            setAddress("")
            setEmailOrPhone("")
            setSelectedType("")
            setFilterDialogOpen(true)
        } else {
            setFilterDialogOpen(true)
        }
    }

    const handleFilterDialogClose = () => {
        setFilterDialogOpen(false)
    }

    const handleChangePage = (event, newPage) => {
        localStorage.setItem("recruitersNewPage", newPage)
        setPage(newPage);
        setTriggerApi(true)
    };

    const handleExternalPage = (event, newPage) => {
        localStorage.setItem("externalRecruiterNewPage", newPage)
        setExternalPage(newPage);
        setTriggerApi(true)
    };

    const handleOpenMappingDialog = () => {
        setOpenClientMappingDialog(true)
        getClientDropdownData()
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const [checked, setChecked] = useState({});
    const [item, setItem] = useState([])

    const handleChangeStatus = (index, event, item) => {
        setChecked((prevStatus) => ({
            ...prevStatus, [index]: event.target.checked
        }))

        if (item?.mappedClientStatus === "Active") {
            setOpenWarningDialog(true)
            setItem(item)
        } else {
            changeAssignedClientStatus(item)
        }
    };

    const handleInactiveClient = () => {
        if (reason === "") {
            setIsReason(true);
        } else {
            changeAssignedClientStatus(item)
            setOpenWarningDialog(false)
        }
    }



    // APIs
    const [getInternalRecruiterList] = useInternalRecruiterListMutation()
    const [getExternalRecruiterList] = useExternalRecruiterListMutation()
    const { data: recruiterDropDown } = useRecruiterDropDownQuery()
    const [recruiterJobList] = useRecruiterJobListMutation()
    const [assignClientToRecruiter] = useRecruiterClientAssignMutation()
    const { data: getClientDropdown, refetch } = useGetClientDropdownForJobQuery()
    const [assignedClientList] = useRecruiterClientAssignedListMutation()
    const [AssignClientStatus] = useUnassignMappedClientMutation()
    const [getRecruiterAssignClients] = useGetRecruiterAssignClientsMutation()


    // dialog box 
    const [open, setOpen] = useState(false);
    const [openClientList, setOpenClientList] = useState(false)
    const [openClientMappingDialog, setOpenClientMappingDialog] = useState(false)
    const handleClose = () => {
        setOpen(false);
        setOpenClientList(false)
        setAssignClientList([])
        setChecked({});

    }

    const handleCloseMappingDialog = () => {
        setOpenClientMappingDialog(false)
    }


    const handleSearchKeywordChange = (e) => {
        const value = e.target.value
        setRecruiterName(value)
        setPage(1)
        setExternalPage(1)
        setTriggerApi(true)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            recruiter: {
                ...currentFilter.recruiter,
                name: value
            }
        };
        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter));
    }

    const handleRecruiterDropdwon = (value) => {
        setSelectedType(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            recruiter: {
                ...currentFilter.recruiter,
                status: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleRecruiterIdChange = (e) => {
        const value = e.target.value
        setRecruiterId(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            recruiter: {
                ...currentFilter.recruiter,
                id: value
            }
        };
        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter));
    }

    const handleRecruiterNameChange = (e) => {
        const value = e.target.value
        setRecruiterName(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            recruiter: {
                ...currentFilter.recruiter,
                name: value
            }
        };
        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter));
    }

    const handleCompanyNameChange = (e) => {
        const value = e.target.value
        setCompany(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            recruiter: {
                ...currentFilter.recruiter,
                company: value,
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleAddressChange = (e) => {
        const value = e.target.value
        setAddress(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            recruiter: {
                ...currentFilter.recruiter,
                address: value
            }
        }
        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleEmailPhoneChange = (e) => {
        const value = e.target.value
        setEmailOrPhone(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            recruiter: {
                ...currentFilter.recruiter,
                emailOrPhone: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleGetMappingClient = (value) => {
        setMappingClient(value)
    }

    useEffect(() => {
        const recruiter = commonFilter?.recruiter;

        const hasValue = recruiter && Object.values(recruiter).some(value =>
            value !== "" && value !== 0 && value !== null && value !== undefined
        );

        if (hasValue) {
            setShouldFetch(hasValue);
        } else {
            setShouldFetch(false)
        }
    }, [])

    const recruiterList = async () => {
        try {
            const payload = {
                page: recruiterName === "" ? (page - 1) : 0,
                size: rowsPerPage,
                id: recruiterId,
                name: recruiterName,
                company: company,
                address: address,
                status: selectedType === 'All' ? "" : selectedType,
                emailOrPhone: emailOrPhone,
                // reason: "",
                sortingColumn: sortingColumn,
                sortingDirection: sortingDirection,
            }
            setShowTableLoader(true)
            const response = await getInternalRecruiterList(payload).unwrap()
            setShowTableLoader(false)
            setInternalRecruiter(response?.response?.data);
            setCount(response?.response?.Count)

        } catch (error) {
            Snackbar("Network error", 'error')
            setShowTableLoader(false)
        }
    }

    const externalRecruiterList = async () => {
        try {
            const payload = {
                page: recruiterName === "" ? (externalPage - 1) : 0,
                size: rowsPerPage,
                id: recruiterId,
                name: recruiterName ? recruiterName : searchKeyword,
                company: company,
                address: address,
                status: selectedType === 'All' ? "" : selectedType,
                emailOrPhone: emailOrPhone,
                // reason: "",
                sortingColumn: sortingColumn,
                sortingDirection: sortingDirection,
            }
            setShowTableLoader(true)
            const response = await getExternalRecruiterList(payload).unwrap()
            setShowTableLoader(false)
            setExternalRecruiter(response?.response?.data);
            setExternalCount(response?.response?.Count)

        } catch (error) {
            Snackbar("Network error", 'error')
            setShowTableLoader(false)
        }
    }

    const [chips, setChips] = useState([])

    const letsFilterDatas = () => {
        const updatedChip = ([
            {
                label: recruiterId,
                onDelete: () => {
                    setRecruiterId('')
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            recruiter: {
                                ...commonFilter.recruiter,
                                id: "",
                            }
                        })
                    )
                    setTriggerApi(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== recruiterId))
                }
            },
            {
                label: company,
                onDelete: () => {
                    setCompany('')
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            recruiter: {
                                company: ''
                            }
                        })
                    )
                    setTriggerApi(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== company))
                }
            },
            {
                label: emailOrPhone,
                onDelete: () => {
                    setEmailOrPhone('')
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            recruiter: {
                                emailOrPhone: ''
                            }
                        })
                    )
                    setTriggerApi(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== emailOrPhone))
                }
            },
            // {
            //     label: recruiterName,
            //     onDelete: () => {
            //         setRecruiterName('')
            //         localStorage.setItem(
            //             'commonsearchfilter',
            //             JSON.stringify({
            //                 ...commonFilter,
            //                 recruiter: {
            //                     recruiterName: '',
            //                 }
            //             })
            //         )
            //         setTriggerApi(true)
            //         setChips(prevChips => prevChips?.filter(chips => chips?.label !== recruiterName))
            //     }
            // },
            {
                label: address,
                onDelete: () => {
                    setAddress('')
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            recruiter: {
                                address: "",
                            }
                        })
                    )
                    setTriggerApi(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== address))
                }
            },
            {
                label: selectedType,
                onDelete: () => {
                    setSelectedType("")
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            recruiter: {
                                selectedType: '',
                            }
                        })
                    )
                    setTriggerApi(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== selectedType))
                }
            }
        ]).filter(Boolean)

        setChips(updatedChip)
        setShowClearFilter(true)
        setTriggerApi(true)
    }

    useEffect(() => {
        if (value === "0") {
            recruiterList()
        } else {
            externalRecruiterList()
        }
    }, [value])

    useEffect(() => {
        if (triggerApi && value === "0") {
            recruiterList()
            handleFilterDialogClose()
            setTriggerApi(false)

        } else if (triggerApi && value === "1") {
            externalRecruiterList()
            handleFilterDialogClose()
            setTriggerApi(false)

        }
    }, [getInternalRecruiterList, selectedType, rowsPerPage, page, sortingDirection, triggerApi, recruiterId, recruiterName, company, address, emailOrPhone, searchKeyword, externalRecruiterList, externalPage])

    const handleSort = (columnName) => {
        if (sortingColumn === columnName) {
            setSortingDirection((prev) => prev === 'ASC' ? 'DESC' : 'ASC')
            setTriggerApi(true)
        } else {
            setSortingDirection('ASC')
            setSortingColumn(columnName)
        }
    }

    const handleClearFilterChange = () => {
        setRecruiterId("")
        setRecruiterName("")
        setCompany("")
        setAddress("")
        setEmailOrPhone("")
        setSelectedType("")
        setTriggerApi(true)
        setShowClearFilter(false)
    }

    const viewRecruiterJobList = async (item) => {
        setOpen(true)
        try {
            const payload = {
                recruiterId: item?.recruiterId
            }
            const response = await recruiterJobList(payload).unwrap()
            setRecruiterJobListDetails(response?.response)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }


    const [BAName, setBAName] = useState("")
    const [BAEmail, setBAEmail] = useState("")
    const [BAId, setBAId] = useState("")

    const viewClientDetails = (item) => {
        setOpenClientList(true)
        setRecruiterUserId(item?.recruiterUserId)
        getAssignedClientsList(item?.recruiterUserId)
        setBAName(item?.recruiterName)
        setBAEmail(item?.email)
        setBAId(item?.recruiterUserId)

    }

    const getAssignedClientsList = async (recruiterUserId) => {
        try {
            const payload = {
                page: 0,
                size: 10,
                recruiterUserId: recruiterUserId || BAId
            }
            const response = await assignedClientList(payload).unwrap()
            setAssignClientList(response?.response)
        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    const mapClientToRecruiter = async () => {
        try {
            const payload = {
                recruiterUserId: recruiterUserId,
                clientId: mappingClient
            }
            const response = await assignClientToRecruiter(payload).unwrap()
            if (response?.response?.status === "error") {
                Snackbar(response?.response?.message, 'error')
            } else {
                Snackbar(response?.response?.message, 'success')
            }

            getAssignedClientsList(recruiterUserId)
            setOpenClientMappingDialog(false)
            setMappingClient("")
        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    const recruiterDetailNavigation = async (item) => {
        localStorage.removeItem("selectedTab");
        await dispatch(updateRecruiterIdAdmin(item?.recruiterId))
        await dispatch(updateRecruiterStatus(item?.status))
        await dispatch(updateExternalRecruiter(item?.isExternalRecruiter))
        navigate('/recruiter-details', {
            state: {
                recruiterId: item?.recruiterId,
                recruiterName: item?.recruiterName,
                addressone: item?.addressone,
                state: item?.state,
                phone: item?.phone,
                email: item?.email,
                companyName: item?.companyName,
                city: item?.city,
                pincode: item?.pincode,
                alternatePhone: item?.alternatePhone,
                alternateEmail: item?.alternateEmail,
                status: item?.status,
                reasonDesc: item?.reasonDescription,
                rewardType: item?.rewardType,
                rewardAmount: item?.rewardAmt,
                rewardPercentage: item?.rewardPct,
                external: item?.isExternalRecruiter,
            }
        })
    }

    const changeAssignedClientStatus = async (item) => {

        try {
            const params = {
                clientMappedStatus: item?.mappedClientStatus === "Active" ? "Inactive" : "Active",
                feedBack: reason,
                clientId: item?.clientId,
                recruiterUserId: BAId,
            }

            const response = await AssignClientStatus(params).unwrap()
            Snackbar(response?.response, 'success')
            getAssignedClientsList()
            setReason("")

        } catch (error) {
            Snackbar("Netowork error", 'error')
        }
    }

    const [clientList, setClietList] = useState([])

    const getClientDropdownData = async () => {
        try {
            const payload = {
                recruiterUserId: BAId
            }
            const response = await getRecruiterAssignClients(payload).unwrap()
            setClietList(response?.response)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    // const chips = [
    //     {
    //         label: recruiterId,
    //         onDelete: () => {
    //             setRecruiterId('')
    //             setTriggerApi(true)
    //         }
    //     },
    //     {
    //         label: company,
    //         onDelete: () => {
    //             setCompany('')
    //             setTriggerApi(true)
    //         }
    //     },
    //     {
    //         label: emailOrPhone,
    //         onDelete: () => {
    //             setEmailOrPhone('')
    //             setTriggerApi(true)
    //         }
    //     },
    //     {
    //         label: recruiterName,
    //         onDelete: () => {
    //             setRecruiterName('')
    //             setTriggerApi(true)
    //         }
    //     },
    //     {
    //         label: address,
    //         onDelete: () => {
    //             setAddress('')
    //             setTriggerApi(true)
    //         }
    //     },
    //     {
    //         label: selectedType,
    //         onDelete: () => {
    //             setSelectedType("")
    //             setTriggerApi(true)
    //         }
    //     }
    // ]

    useEffect(() => {
        if (chips?.every((name) => !name?.label)) {
            setShowClearFilter(false)
        }
    }, [triggerApi])

    // const filteredTableDatas = recruiterDetails?.filter((item) => {
    //     return (
    //         (item?.recruiterName?.toLowerCase()?.startsWith(searchKeyword?.toLowerCase())) ||
    //         (item?.companyName?.toLowerCase()?.startsWith(searchKeyword?.toLowerCase()))
    //     )
    // })

    useEffect(() => {
        if (shouldFetch) {
            letsFilterDatas();
            setShouldFetch(false)
        }
    }, [page, externalPage, shouldFetch]);

    const handleAddRecruiterNav = () => {
        navigate('/addRecruiter', {
            state: {
                value: value
            }
        })
    }

    const [reason, setReason] = useState("");
    const [isReason, setIsReason] = useState(false);


    const handleReason = (e) => {
        setReason(e.target.value);
        setIsReason(false);
    };

    const handleCloseWarining = () => {
        setOpenWarningDialog(false);
        setReason("");
        setIsReason(false);
    };

    const hanldeNavBAPerformance = (item) => {
        navigate('/BA-performance' , {
            state:{
                recruiterUserId:item?.recruiterUserId
            }
        })
    }

    return (
        <Box className="container">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography className="title">Recruiters</Typography>
                <Grid2 item sx={{ display: 'flex', justifyContent: 'space-between' }} gap={3}>
                    <Box>
                        <TextField
                            value={recruiterName}
                            onChange={handleSearchKeywordChange}
                            className="textfields"
                            placeholder='Search By Recruiter'
                            slotProps={{
                                input: {
                                    startAdornment: <SearchIconLg style={{ paddingRight: '5px' }} />
                                }
                            }}
                        />
                    </Box>
                    <Box>
                        <MUICancelButton title={value === "0" ? "Add Internal Recruiter" : "Add Business Associate"}
                            sx={{ border: '1px solid #7F56D9', color: '#ffffff', backgroundColor: '#7F56D9', width: 'auto' }}
                            startIcon={<AddIcon />}
                            onClick={handleAddRecruiterNav}
                        ></MUICancelButton>
                    </Box>
                </Grid2>
            </div>

            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList
                        onChange={handleChange}
                        aria-label="Overview and Candidates tabs"
                        textColor="primary"
                        indicatorColor="secondary"
                    >
                        <Tab
                            label="Internal Recruiters"
                            value="0"
                            className="tabs"
                            sx={{
                                textTransform: 'none',
                                fontWeight: value === "0" ? 'bold' : 'normal',
                                transition: 'all 0.3s ease',
                            }}
                        />

                        <Tab
                            label="Business Associates"
                            value="1"
                            className="tabs"
                            sx={{
                                textTransform: 'none',
                                fontWeight: value === "1" ? 'bold' : 'normal',
                                transition: 'all 0.3s ease',
                            }}
                        />
                    </TabList>
                </Box>

                {/* tabs  */}
                <TabPanel value="0" sx={{ display: 'flex', padding: "0px" }}>
                    <Paper sx={{ width: '100%', overflow: 'auto', marginTop: '10px', border: '1px solid #E9EAEB' }} elevation={0}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan={100} sx={{ padding: '5px' }} >
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div>
                                                    {showClearFilter && (
                                                        chips?.map((item, index) => {
                                                            return (
                                                                item?.label && (
                                                                    <Chip
                                                                        className="Chip"
                                                                        size='small'
                                                                        variant="outlined"
                                                                        key={index}
                                                                        label={item?.label}
                                                                        onDelete={item?.onDelete}
                                                                        deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />}
                                                                    />
                                                                )
                                                            )
                                                        })
                                                    )}
                                                </div>
                                                <div style={{ display: 'flex', gap: '14px' }}>
                                                    <MUICancelButton title='More Filters' onClick={handleFilterDialogOpen} startIcon={<FilterListIcon sx={{ fontSize: '20px !important' }} />} sx={{ color: '#6941C6', borderColor: '#D6BBFB', fontWeight: 600, width: '130px' }} />
                                                    {(recruiterId || company || emailOrPhone || recruiterName || address || selectedType) && showClearFilter && (
                                                        <MUICancelButton title='Clear Filter' onClick={handleClearFilterChange} sx={{ width: '100px' }} />
                                                    )}
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        {/* <TableCell className='tableHeadersCell'> Id</TableCell> */}
                                        <TableCell className='tableHeadersCell'>
                                            <div
                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                                onClick={() => handleSort('created_date')}
                                            >
                                                Name
                                                <UnfoldMoreIcon sx={{ fontSize: '17px' }} />
                                            </div>
                                        </TableCell>
                                        <TableCell className='tableHeadersCell'> Company</TableCell>
                                        <TableCell className='tableHeadersCell'> Address</TableCell>
                                        <TableCell className='tableHeadersCell'> Email/Phone</TableCell>
                                        {/* <TableCell className='tableHeadersCell_2'>External Recruiter</TableCell> */}
                                        <TableCell className='tableHeadersCell'> Status</TableCell>
                                        <TableCell className='tableHeadersCell'> Created date</TableCell>
                                        <TableCell className='tableHeadersCell'>
                                            <Tooltip slotProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: "#0A0D12",
                                                        borderRadius: '8px',
                                                        padding: '8px 12px',
                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                    }
                                                }
                                            }} title='Assigned Job' arrow placement="top">
                                                <span>Assigned Job</span>
                                            </Tooltip>
                                        </TableCell>

                                    </TableRow>
                                </TableHead>
                                {!showTableLoader ? (
                                    internalRecruiters?.length > 0 ? (
                                        <TableBody>
                                            {
                                                internalRecruiters?.map((item, index) => {
                                                    const firstLetter = item?.recruiterName
                                                    const letter = firstLetter?.charAt(0)?.toUpperCase()
                                                    const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                                                    const backgroundColor = colors[index % colors?.length]
                                                    return (
                                                        <TableRow
                                                            sx={{
                                                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                                '&:hover': { backgroundColor: '#f1f1f1' },
                                                            }}
                                                        >
                                                            {/* <TableCell className='tableBodyCell' sx={{ color: '#6941C6', cursor: 'pointer', fontWeight: 550 }}
                                                        onClick={(e) => recruiterDetailNavigation(item)}
                                                    >{item.recruiterId}</TableCell> */}
                                                            <TableCell className='tableBodyCell' onClick={(e) => recruiterDetailNavigation(item)}>
                                                                <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center', color: '#535862', cursor: 'pointer' }}>
                                                                    <Avatar sx={{ backgroundColor: backgroundColor, width: 30, height: 30, fontSize: '14px' }}>{letter}</Avatar>
                                                                    <span style={{ color: "#6941C6", fontWeight: "bold", fontSize: "14px", }}>
                                                                        {item.recruiterName}
                                                                    </span>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell className='tableBodyCell' sx={{ color: '#181D27' }}>{item.companyName === "" ? "-" : item.companyName === null ? "-" : item.companyName}</TableCell>
                                                            <TableCell className='tableBodyCell' sx={{ color: '#181D27' }}>{item.addressone}</TableCell>
                                                            <TableCell className='tableBodyCell' sx={{ color: '#181D27' }}>{item.email}/<br></br>{item.phone}</TableCell>
                                                            {/* <TableCell className='tableBodyCell' >
                                                    <Box sx={{ border: '1px solid #000000', borderRadius: '5px', height: '20px', color: "#ffffff", textAlign: 'center', backgroundColor: item.status == "Approved" ? "#3d9207" : "#da0f0f", cursor: 'pointer ' }}>
                                                        {item.status}
                                                    </Box>
                                                </TableCell> */}
                                                            {/* <TableCell className="tableBodyCell" sx={{ Color: '#181D27' }}>{item?.isExternalRecruiter === "N" ? 'No' : 'Yes'}</TableCell> */}
                                                            <TableCell className="tableBodyCell">
                                                                <Tooltip placement="top" title={item?.status}
                                                                    slotProps={{
                                                                        tooltip: {
                                                                            sx: {
                                                                                backgroundColor: "#0A0D12",
                                                                                borderRadius: '8px',
                                                                                padding: '8px 12px',
                                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                            }
                                                                        }
                                                                    }}>
                                                                    <span
                                                                        className={`status-circle ${item?.status?.toLowerCase()}`}
                                                                    >
                                                                        <span style={{ fontSize: "10px", cursor: "default" }}>
                                                                            {item?.status === "Approved"
                                                                                ? "✓"
                                                                                : item?.status === "Suspended"
                                                                                    ? "✕"
                                                                                    : "–"}
                                                                        </span>
                                                                    </span>
                                                                </Tooltip>
                                                            </TableCell>
                                                            <TableCell className='tableBodyCell' sx={{ width: '10%' }}>{dayjs(item.createdDate).format("DD-MM-YYYY")}</TableCell>
                                                            <TableCell className="tableBodyCell">

                                                                <Tooltip title="View history"
                                                                    slotProps={{
                                                                        tooltip: {
                                                                            sx: {
                                                                                backgroundColor: "#0A0D12",
                                                                                borderRadius: '8px',
                                                                                padding: '8px 12px',
                                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                            }
                                                                        }
                                                                    }}>
                                                                    <VisibilityOutlinedIcon
                                                                        onClick={(e) => viewRecruiterJobList(item)}
                                                                        className="icons"
                                                                        sx={{ cursor: "pointer" }}
                                                                    />
                                                                </Tooltip>
                                                            </TableCell>

                                                        </TableRow>
                                                    )
                                                })
                                            }
                                        </TableBody>
                                    ) : (<TableBody>
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography className="emptydatas">No Data Found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                    )
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Box className='tableloader'>
                                                <TableLoader />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {Math.ceil(count / rowsPerPage) > 1 && (
                                    <TableRow>
                                        <TableCell colSpan={100}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MUICancelButton
                                                    startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                    title='Previous'
                                                    onClick={() => handleChangePage(null, page - 1)}
                                                    disabled={page === 1}
                                                    sx={{ height: '36px' }}
                                                />

                                                <Pagination
                                                    page={page}
                                                    onChange={handleChangePage}
                                                    count={Math.ceil(count / rowsPerPage)}
                                                    shape="rounded"
                                                    siblingCount={1}
                                                    boundaryCount={1}
                                                    hidePrevButton
                                                    hideNextButton
                                                />

                                                <MUICancelButton
                                                    title='Next'
                                                    startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                    onClick={() => handleChangePage(null, page + 1)}
                                                    disabled={page === Math.ceil(count / rowsPerPage)}
                                                    sx={{ height: '36px' }}
                                                />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </Table>
                        </TableContainer>
                    </Paper>

                </TabPanel>

                <TabPanel value="1" sx={{ padding: '0px' }}>
                    <Paper sx={{ width: '100%', overflow: 'auto', marginTop: '10px', border: '1px solid #E9EAEB' }} elevation={0}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan={100} sx={{ padding: '5px' }}
                                        >
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div>
                                                    {showClearFilter && (
                                                        chips?.map((item, index) => {
                                                            return (
                                                                item?.label && (
                                                                    <Chip
                                                                        className="Chip"
                                                                        size='small'
                                                                        variant="outlined"
                                                                        key={index}
                                                                        label={item?.label}
                                                                        onDelete={item?.onDelete}
                                                                        deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />}
                                                                    />
                                                                )
                                                            )
                                                        })
                                                    )}
                                                </div>
                                                <div style={{ display: 'flex', gap: '14px' }}>
                                                    <MUICancelButton title='More Filters' onClick={handleFilterDialogOpen} startIcon={<FilterListIcon sx={{ fontSize: '20px !important' }} />} sx={{ color: '#6941C6', borderColor: '#D6BBFB', fontWeight: 600, width: '130px' }} />
                                                    {(recruiterId || company || emailOrPhone || recruiterName || address || selectedType) && showClearFilter && (
                                                        <MUICancelButton title='Clear Filter' onClick={handleClearFilterChange} sx={{ width: '100px' }} />
                                                    )}
                                                </div>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        {/* <TableCell className='tableHeadersCell'> Id</TableCell> */}
                                        <TableCell className='tableHeadersCell'>
                                            <div
                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                                onClick={() => handleSort('created_date')}
                                            >
                                                Name
                                                <UnfoldMoreIcon sx={{ fontSize: '17px' }} />
                                            </div>
                                        </TableCell>
                                        <TableCell className='tableHeadersCell'> Company</TableCell>
                                        <TableCell className='tableHeadersCell'> Address</TableCell>
                                        <TableCell className='tableHeadersCell'> Email/Phone</TableCell>
                                        {/* <TableCell className='tableHeadersCell_2'>External Recruiter</TableCell> */}
                                        <TableCell className='tableHeadersCell'> Status</TableCell>
                                        <TableCell className='tableHeadersCell'> Created date</TableCell>
                                        <TableCell className='tableHeadersCell'>
                                            <Tooltip
                                                slotProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: "#0A0D12",
                                                            borderRadius: '8px',
                                                            padding: '8px 12px',
                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                        }
                                                    }
                                                }} title='Assigned Job' arrow placement="top">
                                                <span>Assigned Job</span>
                                            </Tooltip>
                                        </TableCell>

                                    </TableRow>
                                </TableHead>
                                {!showTableLoader ? (
                                    externalRecruiter?.length > 0 ? (
                                        <TableBody>
                                            {
                                                externalRecruiter?.map((item, index) => {
                                                    const firstLetter = item?.recruiterName
                                                    const letter = firstLetter?.charAt(0)?.toUpperCase()
                                                    const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                                                    const backgroundColor = colors[index % colors?.length]
                                                    return (
                                                        <TableRow
                                                            sx={{
                                                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                                '&:hover': { backgroundColor: '#f1f1f1' },
                                                            }}
                                                        >
                                                            {/* <TableCell className='tableBodyCell' sx={{ color: '#6941C6', cursor: 'pointer', fontWeight: 550 }}
                                                        onClick={(e) => recruiterDetailNavigation(item)}
                                                    >{item.recruiterId}</TableCell> */}
                                                            <TableCell className='tableBodyCell' onClick={(e) => recruiterDetailNavigation(item)}>
                                                                <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center', color: '#535862', cursor: 'pointer' }}>
                                                                    <Avatar sx={{ backgroundColor: backgroundColor, width: 30, height: 30, fontSize: '14px' }}>{letter}</Avatar>
                                                                    <span style={{ color: "#6941C6", fontWeight: "bold", fontSize: "14px", }}>
                                                                        {item.recruiterName}
                                                                    </span>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell className='tableBodyCell' sx={{ color: '#181D27' }}>{item.companyName === null ? "-" : item.companyName === "" ? "-" : item.companyName}</TableCell>
                                                            <TableCell className='tableBodyCell' sx={{ color: '#181D27' }}>{item.addressone}</TableCell>
                                                            <TableCell className='tableBodyCell' sx={{ color: '#181D27' }}>{item.email}/<br></br>{item.phone}</TableCell>
                                                            {/* <TableCell className='tableBodyCell' >
                                                    <Box sx={{ border: '1px solid #000000', borderRadius: '5px', height: '20px', color: "#ffffff", textAlign: 'center', backgroundColor: item.status == "Approved" ? "#3d9207" : "#da0f0f", cursor: 'pointer ' }}>
                                                        {item.status}
                                                    </Box>
                                                </TableCell> */}
                                                            {/* <TableCell className="tableBodyCell" sx={{ Color: '#181D27' }}>{item?.isExternalRecruiter === "N" ? 'No' : 'Yes'}</TableCell> */}
                                                            <TableCell className="tableBodyCell">
                                                                <div className="status-checkboxes">
                                                                    <Tooltip placement="top" title="Level One Approval"
                                                                        slotProps={{
                                                                            tooltip: {
                                                                                sx: {
                                                                                    backgroundColor: "#0A0D12",
                                                                                    borderRadius: '8px',
                                                                                    padding: '8px 12px',
                                                                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                                }
                                                                            }
                                                                        }}>
                                                                        <span
                                                                            className={`status-circle ${item?.status === "Approved"
                                                                                ? "approved"
                                                                                : item?.status === "Suspended"
                                                                                    ? "suspended"
                                                                                    : "pending"
                                                                                }`}
                                                                            title="First Level Approval"
                                                                        >
                                                                            <span style={{ fontSize: "10px", cursor: "default" }}>
                                                                                {item?.status === "Approved"
                                                                                    ? "✓"
                                                                                    : item?.status === "Suspended"
                                                                                        ? "✕"
                                                                                        : "–"}
                                                                            </span>
                                                                        </span>

                                                                    </Tooltip>

                                                                    {/* Second Level Approval */}
                                                                    <Tooltip placement="top" title="Level Two Approval"
                                                                        slotProps={{
                                                                            tooltip: {
                                                                                sx: {
                                                                                    backgroundColor: "#0A0D12",
                                                                                    borderRadius: '8px',
                                                                                    padding: '8px 12px',
                                                                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                                }
                                                                            }
                                                                        }}>
                                                                        <span
                                                                            className={`status-circle ${item?.isDocsVerify === "Y"
                                                                                ? "approved"
                                                                                : item?.isDocsVerify === "N"
                                                                                    ? "suspended"
                                                                                    : "pending"
                                                                                }`}
                                                                            title="Second Level Approval"
                                                                        >
                                                                            <span style={{ fontSize: "10px", cursor: "default" }}>

                                                                                {item?.isDocsVerify === "Y"
                                                                                    ? "✓"
                                                                                    : item?.isDocsVerify === "N"
                                                                                        ? "✕"
                                                                                        : "–"}
                                                                            </span>
                                                                        </span>
                                                                    </Tooltip>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className='tableBodyCell' sx={{ width: '10%' }}>{dayjs(item.createdDate).format("DD-MM-YYYY")}</TableCell>
                                                            <TableCell className="tableBodyCell" sx={{width:'10%'}}>
                                                                <Tooltip title="View history"
                                                                    slotProps={{
                                                                        tooltip: {
                                                                            sx: {
                                                                                backgroundColor: "#0A0D12",
                                                                                borderRadius: '8px',
                                                                                padding: '8px 12px',
                                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                            }
                                                                        }
                                                                    }}>
                                                                    <VisibilityOutlinedIcon
                                                                        onClick={(e) => viewRecruiterJobList(item)}
                                                                        className="icons"
                                                                        sx={{ cursor: "pointer" }}
                                                                    />
                                                                </Tooltip>
                                                                <Tooltip title={item?.status === "Approved" ? "Client Details" : "This recruiter hasn't approved it, so you can't view the client details."}
                                                                    slotProps={{
                                                                        tooltip: {
                                                                            sx: {
                                                                                backgroundColor: "#0A0D12",
                                                                                borderRadius: '8px',
                                                                                padding: '8px 12px',
                                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                            }
                                                                        }
                                                                    }}>
                                                                    <SupervisorAccountOutlinedIcon
                                                                        onClick={item?.status === "Approved" ? ((e) => viewClientDetails(item)) : null}
                                                                        className="icons"
                                                                        sx={{ cursor: item?.status === "Approved" ? "pointer" : "not-allowed" }}
                                                                    />
                                                                </Tooltip>
                                                                {/* <Tooltip title={item?.status === "Approved" ? "BA Performance" : ""}
                                                                    slotProps={{
                                                                        tooltip: {
                                                                            sx: {
                                                                                backgroundColor: "#0A0D12",
                                                                                borderRadius: '8px',
                                                                                padding: '8px 12px',
                                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                            }
                                                                        }
                                                                    }}>
                                                                    <TrendingUpDown
                                                                        onClick={item?.status === "Approved" ? ((e) => hanldeNavBAPerformance(item)) : null}
                                                                        className="icons"
                                                                        size={16} 
                                                                        style={{
                                                                            cursor: item?.status === "Approved" ? "pointer" : "not-allowed"
                                                                        }}
                                                                    />
                                                                </Tooltip> */}
                                                            </TableCell>

                                                        </TableRow>
                                                    )
                                                })
                                            }
                                        </TableBody>
                                    ) : (<TableBody>
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography className="emptydatas">No Data Found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                    )
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Box className='tableloader'>
                                                <TableLoader />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {Math.ceil(externalCount / rowsPerPage) > 1 && (
                                    <TableRow>
                                        <TableCell colSpan={100}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MUICancelButton
                                                    startIcon={<ArrowBackIcon sx={{ color: externalPage === 1 ? '#a2a2a2' : '#414651' }} />}
                                                    title='Previous'
                                                    onClick={() => handleExternalPage(null, externalPage - 1)}
                                                    disabled={externalPage === 1}
                                                    sx={{ height: '36px' }}
                                                />

                                                <Pagination
                                                    page={externalPage}
                                                    onChange={handleExternalPage}
                                                    count={Math.ceil(externalCount / rowsPerPage)}
                                                    shape="rounded"
                                                    siblingCount={1}
                                                    boundaryCount={1}
                                                    hidePrevButton
                                                    hideNextButton
                                                />

                                                <MUICancelButton
                                                    title='Next'
                                                    startIcon={<ArrowForwardIcon sx={{ color: externalPage === Math.ceil(externalCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                    onClick={() => handleExternalPage(null, externalPage + 1)}
                                                    disabled={externalPage === Math.ceil(externalCount / rowsPerPage)}
                                                    sx={{ height: '36px' }}
                                                />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </Table>
                        </TableContainer>
                    </Paper>

                </TabPanel>
            </TabContext>

            <Grid2>
                <Dialog
                    open={open}
                    scroll="paper"
                    maxWidth="md"
                    onClose={handleClose}
                    sx={{
                        "& .MuiDialog-paper": {
                            minWidth: '60vw',
                            minHeight: '75vh'
                        },
                    }}
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '18px', fontWeight: 550 }}>
                        History
                        <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleClose} />
                    </DialogTitle>
                    <DialogContent dividers>

                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='tableHeadersCell'>S.No </TableCell>
                                        <TableCell className='tableHeadersCell'>Client Name </TableCell>
                                        <TableCell className='tableHeadersCell'>Job Title </TableCell>
                                        <TableCell className='tableHeadersCell'>No.of Positions</TableCell>
                                    </TableRow>
                                </TableHead>
                                {recruiterJobListDetails?.length > 0 ? (
                                    <TableBody>
                                        {recruiterJobListDetails?.map((item, index) => {

                                            return (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                        '&:hover': { backgroundColor: '#f1f1f1' },
                                                    }}
                                                >
                                                    <TableCell className='tableBodyCell'>{index + 1}</TableCell>
                                                    <TableCell className='tableBodyCell'>{item.clientName}</TableCell>
                                                    <TableCell className='tableBodyCell'>{item.positionTitle}</TableCell>
                                                    <TableCell className='tableBodyCell'>{item.noOfPosition}</TableCell>
                                                </TableRow>
                                            )
                                        })
                                        }
                                    </TableBody>
                                ) : (<TableBody>
                                    <TableRow>
                                        <TableCell colSpan={4}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <MUICancelButton onClick={handleClose} title='Close'></MUICancelButton>
                    </DialogActions>
                </Dialog>
            </Grid2>

            <Grid2>
                <Dialog
                    open={openClientList}
                    scroll="paper"
                    maxWidth="md"
                    onClose={handleClose}
                    sx={{
                        "& .MuiDialog-paper": {
                            minWidth: '60vw',
                            minHeight: '75vh'
                        },
                    }}
                >
                    <DialogTitle sx={{ display: 'flex' }}>
                        <Box sx={{ width: '50%' }}>
                            <Typography sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}><PersonOutlineIcon className="icons" /> <span style={{ fontWeight: 700 }}> {BAName} </span> </Typography>
                            <Typography sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}><EmailOutlinedIcon className="icons" /> <span style={{ fontWeight: 700 }}>{BAEmail}</span></Typography>
                        </Box>

                        <Box sx={{ width: '60%' }}>
                            <Typography sx={{ fontWeight: 700 }}>Assigned Client</Typography>
                        </Box>

                        <Box>
                            <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleClose} />
                        </Box>
                    </DialogTitle>
                    <DialogContent dividers>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow >
                                        <TableCell className='tableHeadersCell'>S.No </TableCell>
                                        <TableCell className='tableHeadersCell'>Client Name</TableCell>
                                        <TableCell className='tableHeadersCell'>Client Created By</TableCell>
                                        {/* <TableCell className='tableHeadersCell'>Assigned By</TableCell> */}
                                        <TableCell className='tableHeadersCell'>Created Date</TableCell>
                                        <TableCell className='tableHeadersCell'> Is Owned</TableCell>
                                        {/* <TableCell className='tableHeadersCell'>Status</TableCell> */}
                                        <TableCell className='tableHeadersCell'>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                {assignClientToRecruiterList?.length > 0 ? (
                                    <TableBody>
                                        {assignClientToRecruiterList?.map((item, index) => {

                                            return (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                        '&:hover': { backgroundColor: '#f1f1f1' },
                                                    }}
                                                >
                                                    <TableCell className='tableBodyCell'>{index + 1}</TableCell>
                                                    <TableCell className='tableBodyCell'>{item.clientName}</TableCell>
                                                    <TableCell className='tableBodyCell'>{item.clientCreatedName}</TableCell>
                                                    <TableCell className='tableBodyCell'>{dayjs(item.createdDate).format('DD-MM-YYYY')}</TableCell>
                                                    <TableCell className='tableBodyCell'><Typography className={`isOwned-badge ${item?.clientCreatedBy.toLowerCase()}`} >{item.clientCreatedBy === "You" ? "Yes" : "No"}</Typography></TableCell>
                                                    {/* <TableCell className='tableBodyCell'>{item.clientAssignStatus}</TableCell> */}

                                                    {
                                                        item?.clientCreatedBy === "Others" ?
                                                            (
                                                                <TableCell className='tableBodyCell'>
                                                                    <Switch
                                                                        key={index}
                                                                        checked={checked[index] || item?.mappedClientStatus === "Active"}
                                                                        onChange={(event) => handleChangeStatus(index, event, item)}
                                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                                    />
                                                                </TableCell>
                                                            ) : (<TableCell sx={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}> Not Applicable   </TableCell>
                                                            )
                                                    }

                                                </TableRow>
                                            )
                                        })
                                        }
                                    </TableBody>
                                ) : (<TableBody>
                                    <TableRow>
                                        <TableCell colSpan={7}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: '20px' }}>
                            <MUICancelButton onClick={handleClose} title='Close'></MUICancelButton>
                            <MUIButton title="Add Client" onClick={handleOpenMappingDialog} />
                        </Box>
                    </DialogActions>
                </Dialog>
            </Grid2>

            <Grid2 item>
                <Dialog
                    open={openClientMappingDialog}
                    onClose={handleCloseMappingDialog}
                    scroll="paper"
                    maxWidth="xs"
                    sx={{
                        '& .MuiDialog-paper': {
                            minHeight: '25vh',
                            minWidth: '25vw',
                            borderRadius: '20px',
                            overflow: 'auto',
                        },
                        marginLeft: '70px',
                    }}
                >
                    <DialogTitle sx={{ borderBottom: "1px solid #E9EAEB", marginBottom: '5px', fontSize: '20px', fontWeight: 700 }}>Mapping the client to the Recruiter</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ marginTop: '5px' }}>Select Client<span style={{ color: 'red' }}>*</span></Typography>
                                    <Dropdown
                                        placeholder="Select Client"
                                        options={clientList || []}
                                        valueKey='clientId'
                                        labelKey='clientName'
                                        sx={{
                                            "& .MuiSelect-select.Mui-disabled": {
                                                cursor: "not-allowed",
                                            },
                                            marginTop: '10px'
                                        }}
                                        value={mappingClient}
                                        onChange={(value) => handleGetMappingClient(value)}
                                    />
                                </Box>
                            </Box>
                            <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <MUICancelButton title='Cancel' onClick={() => {
                                    setOpenClientMappingDialog(false)
                                    setMappingClient("")
                                }} />
                                <Tooltip
                                    slotProps={{
                                        tooltip: {
                                            sx: {
                                                backgroundColor: "#0A0D12",
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                            }
                                        }
                                    }}
                                    arrow placement="top" title={!mappingClient ? "Select client" : ""}>
                                    <span>
                                        <MUIButton title='Assign' onClick={mapClientToRecruiter} disabled={!mappingClient} />
                                    </span>
                                </Tooltip>
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </Grid2>

            {/* More filters Dialog */}
            <Grid2 item>
                <Dialog
                    open={FilterDialogOpen}
                    maxWidth='md'
                    scroll="paper"
                    className="sidePopup"
                >
                    <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '18px', fontWeight: 550 }}>
                        Filters
                        <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleFilterDialogClose} />
                    </DialogTitle>
                    <DialogContent>
                        <Grid2 container sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} gap={2}>
                                <Grid2 item>
                                    <InputLabel className="inputlabels">Recruiter Id</InputLabel>
                                    <TextField
                                        value={recruiterId}
                                        onChange={handleRecruiterIdChange}
                                        className='textfields'
                                        placeholder='Enter Recruiter Id'
                                    />
                                </Grid2>

                                <Grid2 item>
                                    <InputLabel className="inputlabels">Company</InputLabel>
                                    <TextField
                                        value={company}
                                        onChange={handleCompanyNameChange}
                                        className='textfields'
                                        placeholder='Enter Company Name'
                                    />
                                </Grid2>

                                <Grid2 item>
                                    <InputLabel className="inputlabels">Email/Phone</InputLabel>
                                    <TextField
                                        value={emailOrPhone}
                                        onChange={handleEmailPhoneChange}
                                        className='textfields'
                                        placeholder='Enter Email/Phone'
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '15px' }} gap={2}>
                                {/* <Grid2 item>
                                    <InputLabel className="inputlabels">Recruiter Name</InputLabel>
                                    <TextField
                                        value={recruiterName}
                                        onChange={handleRecruiterNameChange}
                                        className='textfields'
                                        placeholder='Enter Recruiter Name'
                                    />
                                </Grid2> */}

                                <Grid2 item>
                                    <InputLabel className="inputlabels">Address</InputLabel>
                                    <TextField
                                        value={address}
                                        onChange={handleAddressChange}
                                        className='textfields'
                                        placeholder='Enter Address'
                                    />
                                </Grid2>

                                <Grid2 item>
                                    <InputLabel className="inputlabels">Status</InputLabel>
                                    <Dropdown
                                        placeholder="Select By Status Type"
                                        value={selectedType || ""}
                                        options={recruiterDropDown?.response?.type || []}
                                        onChange={(value) => handleRecruiterDropdwon(value)}
                                        valueKey="name"
                                        labelKey="name"
                                    />
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </DialogContent>
                    <DialogActions>
                        <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                            <MUICancelButton title='Cancel' sx={{ width: '42%' }} onClick={handleFilterDialogClose} />
                            <MUIButton title='Apply' sx={{ width: '42%' }}
                                onClick={() => {
                                    setPage(1)
                                    setExternalPage(1)
                                    setShouldFetch(true)
                                }}
                            />
                        </Grid2>
                    </DialogActions>
                </Dialog>
            </Grid2>


            <Grid2>
                <Dialog
                    open={openWarningDialog}
                    onClose={handleCloseWarining}
                    scroll="paper"
                    maxWidth="sm"
                    sx={{
                        "& .MuiDialog-paper": {
                            minWidth: "40vw",
                            minHeight: "auto",
                        },
                    }}
                >
                    <DialogTitle
                        dividers
                        sx={{
                            fontWeight: "bold",
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <InputLabel className="inputlabels" sx={{ fontWeight: 600 }}>

                            Reason for Cancellation
                            <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <CloseIcon
                            sx={{ cursor: "pointer", color: "#A4A7AE" }}
                            onClick={handleCloseWarining}
                        />
                    </DialogTitle>
                    <DialogContent sx={{ padding: "20px" }}>
                        <textarea
                            value={reason}
                            onChange={handleReason}
                            placeholder={"Enter Reason"}
                            className="textareas"
                            style={{
                                width: "100%",
                                height: "130px",
                            }}
                        />
                        {isReason && (
                            <span style={{ color: "red", fontSize: "0.8rem" }}>Reason is required</span>
                        )}
                    </DialogContent>

                    <DialogActions
                        sx={{ justifyContent: "flex-end", paddingBottom: "16px" }}
                    >
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={handleCloseWarining}
                            sx={{
                                marginRight: "10px",
                                borderColor: "#a2a2a2",
                                color: "#a2a2a2",
                                textTransform: "none",
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={handleInactiveClient}
                            color={"Warning"}
                            size="small"
                            sx={{
                                marginRight: "10px",
                                borderColor: "#EB1313",
                                color: "#EB1313",
                                textTransform: 'none'
                            }}
                        >
                            Inactive
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid2>


        </Box>
    )
}
export default Recruiters;  